import { FileContents } from "../../shared/data-access/models/file-contents.model";
import { StudentDocumentLabel } from "../../university-dashboard/enums/DocumentTypes";

export interface StudentDocumentData {
    matricCertificate: FileContents;
    academicTranscript: FileContents;
    identityDocument: FileContents
    financialStatement: FileContents;
    profilePicture: FileContents;
}

export interface StudentDocumentConfig {
  displayName: string;
  propertyName: string;
  gradeAverageKey?: string;
}

export const STUDENT_DOCUMENT_CONFIGS: StudentDocumentConfig[] = [
  {
    displayName: StudentDocumentLabel.MATRIC_CERTIFICATE,
    propertyName: 'matricCertificate',
    gradeAverageKey: 'matric'
  },
  {
    displayName: StudentDocumentLabel.ACADEMIC_RECORD,
    propertyName: 'academicTranscript',
    gradeAverageKey: 'academicRecord'
  },
  {
    displayName: StudentDocumentLabel.PROOF_OF_IDENTIFICATION,
    propertyName: 'identityDocument'
  },
  {
    displayName: StudentDocumentLabel.FINANCIAL_STATEMENT,
    propertyName: 'financialStatement'
  }
];
